module.exports = __webpack_public_path__ + "df051a52d6eae227c6d842e5c3392dae.png";